import { render, staticRenderFns } from "./LottoResultByType.vue?vue&type=template&id=28c06f4c&scoped=true"
import script from "./LottoResultByType.vue?vue&type=script&lang=js"
export * from "./LottoResultByType.vue?vue&type=script&lang=js"
import style0 from "./LottoResultByType.vue?vue&type=style&index=0&id=28c06f4c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c06f4c",
  null
  
)

export default component.exports